import App from './app/app';
const app = new App();
app.init();
